import {
  BarChartOutlined,
  BuildOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  InboxOutlined,
  NotificationOutlined,
  PushpinOutlined,
  RocketOutlined,
  SettingOutlined,
  ShopOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import NotFound from 'containers/404';
import AccountSettings from 'containers/AccountSettings';
import Subscription from 'containers/AccountSettings/Subscription';
import UserManagement from 'containers/AccountSettings/UserManagement';
import Login from 'containers/auth';
import ForgetPasswordConfirm from 'containers/auth/ForgetPasswordConfirm';
import Onboarding from 'containers/auth/Onboarding';
import ForgetPassword from 'containers/auth/ResetPassword';
import GmailConnect, { GmailComplete } from 'containers/EmailConnect/GmailConnect';
import OutlookConnect, { OutlookComplete } from 'containers/EmailConnect/OutlookConnect';
import SignUp from 'containers/auth/SignUp';
import Companies from 'containers/CustomerCenter/Companies';
import CompanyInfo from 'containers/CustomerCenter/Companies/CompanyInfo';
import CouponsForm from 'containers/CouponForm';
import Coupons from 'containers/Coupons';
import ContactDetail from 'containers/CustomerCenter/Contacts/Details';
import Contacts from 'containers/CustomerCenter/Contacts/List';
import Dashboard from 'containers/Dashboard';
import EditAddress from 'containers/EditAddress';
import GlobalMenus from 'containers/GlobalMenuManagement/GlobalMenus';
import Location from 'containers/Location';
import Marketing from 'containers/Marketing';
import MarketingDetail from 'containers/MarketingDetail';
import MarketingForm from 'containers/MarketingForm';
import MenuManagementContainer from 'containers/MenuManagement/MenuManagemntContainer';
import MerchantCreateFrom from 'containers/MerchantCreateForm';
import MerchantDetail from 'containers/MerchantDetail';
import MerchantEditFrom from 'containers/MerchantEditForm';
import Merchants from 'containers/Merchants';
import OrdersTab from 'containers/Order/ListOrders';
import DirectEntry from 'containers/Order/CreateOrder';
import EditingOrder from 'containers/Order/EditOrder';
import Reports from 'containers/Reports';
import Support from 'containers/Support';
import React from 'react';
import CustomerDetail from 'containers/CustomerCenter/Contacts/Details/CustomerDetail';
import Automations from 'containers/Workflows/Automations';
import Sequences from 'containers/Workflows/Sequences';
import { PERMISSIONS } from './permissions';
import { SIDEBAR_ITEMS } from './sidebar-items';

export const MainRoutes = {
  LOGIN: {
    path: '/login',
    component: Login,
  },
  SIGNUP: {
    path: '/sign-up',
    component: SignUp,
  },
  DASHBOARD: {
    path: '/console',
    component: Dashboard,
  },
  FORGET_PASSWORD: {
    path: '/forget-password',
    component: ForgetPassword,
  },
  CUSTOMER_ADDRESS_EDIT: {
    path: '/console/customer-address/:id/:addressId',
    component: EditAddress,
  },
  CONTACTS: {
    path: '/console/contacts',
    component: Contacts,
  },
  CUSTOMERS: {
    path: '/console/customers/:id',
    component: CustomerDetail,
  },
  LOCATIONS: {
    path: '/console/locations/*',
    component: Location,
  },
  MERCHANTS: {
    path: '/console/restaurants',
    component: Merchants,
  },
  ACCOUNT_SETTINGS: {
    path: '/console/setting',
    component: AccountSettings,
  },
  COUPONS: {
    path: '/console/coupons',
    component: Coupons,
  },
  DIRECT_ENTRY: {
    path: '/console/orders/direct-entry',
    component: DirectEntry,
  },
  ORDERS: {
    path: '/console/orders/:orderId?',
    component: OrdersTab,
  },
  REPORTS: {
    path: '/console/reports/*',
    component: Reports,
  },
  SUPPORT: {
    path: '/console/support',
    component: Support,
  },
  MARKETING: {
    path: '/console/marketing',
    component: Marketing,
  },
  COMPANIES: {
    path: '/console/companies',
    component: Companies,
  },
  GLOBAL_MENUS: {
    path: '/console/menus/*',
    component: GlobalMenus,
  },
  SEQUENCES: {
    path: '/console/workflows/sequences',
    component: Sequences,
  },
  AUTOMATIONS: {
    path: '/console/workflows/automations',
    component: Automations,
  },
};

// TODO: this routes should be move into nested level on their parents
export const INNER_ROUTES = [
  {
    path: '/onboarding',
    component: Onboarding,
  },
  {
    path: '/redirect/api/user/rest-auth/password/reset/confirm/:uid/:token/',
    component: ForgetPasswordConfirm,
  },
  {
    path: '/redirect/api/v1/user/rest-auth/password/reset/confirm/:uid/:token/',
    component: ForgetPasswordConfirm,
  },
  {
    path: '/console/contacts/:id/*',
    component: ContactDetail,
  },
  {
    path: '/console/marketing/create',
    component: MarketingForm,
  },
  {
    path: '/console/marketing/edit/:id',
    component: MarketingForm,
  },
  {
    path: '/console/restaurants/edit/:id',
    component: MerchantEditFrom,
  },
  {
    path: '/console/restaurants/:id',
    component: MerchantDetail,
  },
  {
    path: '/console/restaurants/create',
    component: MerchantCreateFrom,
  },
  {
    path: '/console/restaurants/:id/menus/*',
    component: MenuManagementContainer,
  },
  {
    path: '/console/marketing/duplicate/:id',
    component: MarketingForm,
  },
  {
    path: '/console/marketing/detail/:id',
    component: MarketingDetail,
  },
  {
    path: '/console/orders/:id/edit',
    component: EditingOrder,
  },
  {
    path: '/console/coupons/form',
    component: CouponsForm,
  },
  {
    path: '/console/coupons/form/:id',
    component: CouponsForm,
  },

  {
    path: '/console/user-management',
    component: UserManagement,
  },

  {
    path: '/console/setting/subscription',
    component: Subscription,
  },
  {
    path: '/console/setting/connect-gmail',
    component: GmailConnect,
  },
  {
    path: '/console/setting/connect-outlook',
    component: OutlookConnect,
  },
  {
    path: '/console/setting/connect-gmail/complete',
    component: GmailComplete,
  },
  {
    path: '/console/setting/connect-outlook/complete',
    component: OutlookComplete,
  },
  {
    path: '/console/companies/:id/info',
    component: CompanyInfo,
  },
  {
    path: '/',
    component: Dashboard,
  },
  {
    path: '*',
    component: NotFound,
  },
];

const resizeIcon = (Icon) => <Icon style={{ fontSize: '16px' }} />;

// to prevent dep-cycle the sidebar-items is populated indirectly
if (SIDEBAR_ITEMS.length === 0) {
  SIDEBAR_ITEMS.push(...[
    {
      route: MainRoutes.DASHBOARD,
      icon: resizeIcon(DashboardOutlined),
      label: 'Dashboard',
    },
    {
      route: {
        path: '/console/orders',
        component: OrdersTab,
      },
      label: 'Orders',
      permissions: [PERMISSIONS.ORDERS],
      icon: resizeIcon(InboxOutlined),
      badge: 'orders',
      action: {
        route: MainRoutes.DIRECT_ENTRY.path,
        label: 'Create order',
      },
    },
    {
      route: MainRoutes.COMPANIES,
      permissions: [PERMISSIONS.COMPANIES, PERMISSIONS.CUSTOMERS],
      label: 'Customer center',
      icon: resizeIcon(TeamOutlined),
      subMenus: [
        {
          route: MainRoutes.COMPANIES,
          permissions: [PERMISSIONS.COMPANIES],
          label: 'Companies',
        },
        {
          route: MainRoutes.CONTACTS,
          permissions: [PERMISSIONS.CUSTOMERS],
          label: 'Contacts',
        },
      ],
    },
    {
      route: MainRoutes.MERCHANTS,
      permissions: [PERMISSIONS.MERCHANTS],
      label: 'Restaurants',
      icon: resizeIcon(ShopOutlined),
      action: {
        route: '/console/restaurants/create',
        label: 'Create restaurant',
      },
    },
    {
      route: {
        path: '/console/menus',
        component: GlobalMenus,
      },
      permissions: [PERMISSIONS.GLOBAL_MENU],
      label: 'Global menus',
      icon: resizeIcon(BuildOutlined),
      action: {
        route: '/console/menus/create',
        label: 'Create menu',
      },
    },
    {
      route: {
        path: '/console/locations',
        component: Location,
      },
      permissions: [PERMISSIONS.PARENTS],
      label: 'Locations',
      icon: resizeIcon(PushpinOutlined),
    },
    {
      route: {
        path: '/console/reports',
        component: Reports,
      },
      permissions: [PERMISSIONS.REPORTS],
      label: 'Reports',
      icon: resizeIcon(BarChartOutlined),
    },
    {
      route: MainRoutes.MARKETING,
      permissions: [PERMISSIONS.MARKETING, PERMISSIONS.COUPONS],
      label: 'Marketing',
      icon: resizeIcon(NotificationOutlined),
      subMenus: [
        {
          route: MainRoutes.MARKETING,
          permissions: [PERMISSIONS.MARKETING],
          label: 'Push notification',
        },
        {
          route: MainRoutes.COUPONS,
          permissions: [PERMISSIONS.COUPONS],
          label: 'Coupons',
        },
      ],
    },
    {
      route: MainRoutes.SEQUENCES,
      permissions: [PERMISSIONS.COMPANIES],
      label: 'Workflows',
      icon: resizeIcon(RocketOutlined),
      subMenus: [
        {
          route: MainRoutes.AUTOMATIONS,
          permissions: [],
          label: 'Automations',
        },
        {
          route: MainRoutes.SEQUENCES,
          permissions: [],
          label: 'Sequences',
        },
      ],
    },
    {
      route: MainRoutes.SUPPORT,
      label: 'Help center',
      icon: resizeIcon(CustomerServiceOutlined),
      permissions: [PERMISSIONS.ADMIN_ACCESS],
      bottom: true,
    },
    {
      route: MainRoutes.ACCOUNT_SETTINGS,
      label: 'Account settings',
      icon: resizeIcon(SettingOutlined),
      bottom: true,
    },
  ]);
}
